import { jsx as _jsx } from "react/jsx-runtime";
import { WagmiProvider } from "wagmi";
import { config } from "../config/wagmi";
export var WithWagmi = function (_a) {
    var children = _a.children;
    return (_jsx(WagmiProvider, { config: config, children: children }));
};
